export const USERS_ALL = 'USERS_ALL';
export const USERS_MY = 'USERS_MY';

export const ADDRESSES_GET_MANY = 'ADDRESSES_GET_MANY';
export const ADDRESSES_HINTS = 'ADDRESSES_HINTS';

export const CLIENTS_GET_MANY = 'CLIENTS_GET_MANY';
export const CLIENTS_SEARCH_HINTS = 'CLIENTS_SEARCH_HINTS';
export const CLIENT_GET_ONE = 'CLIENT_GET_ONE';
export const CLIENT_DEBT = 'CLIENT_DEBT';
export const CLIENT_INSURANCE = 'CLIENT_INSURANCE';
export const CLIENT_INSURANCE_HISTORY = 'CLIENT_INSURANCE_HISTORY';

export const COUNTRIES = 'COUNTRIES';

export const WAREHOUSES_LIST = 'WAREHOUSES_LIST';
export const TRANSPORTS_LIST = 'TRANSPORTS_LIST';
export const TRANSPORTS_REFETCH_LIST = 'TRANSPORTS_REFETCH_LIST';
export const TRANSPORT_SEARCH_HINTS = 'TRANSPORT_SEARCH_HINTS';
export const TRANSPORT_AVAILABILITY_STATUS = 'TRANSPORT_AVAILABILITY_STATUS';
export const TRANSPORT_TACHO_INFO = 'TRANSPORT_TACHO_INFO';

export const CONTACTS_GET_MANY = 'CONTACTS_GET_MANY';
export const CONTACT_GET_ONE = 'CONTACT_GET_ONE';

export const ORDERS_GET_MANY = 'ORDERS_GET_MANY';
export const ORDER_GET_ONE = 'ORDER_GET_ONE';
export const ORDERS_SEARCH_HINTS = 'ORDERS_SEARCH_HINTS';
export const ORDERS_SUMMARY = 'ORDERS_SUMMARY';

export const DOCUMENTS_GET_MANY = 'DOCUMENTS_GET_MANY';

export const COMMENTS_GET_MANY = 'COMMENTS_GET_MANY';

export const CARGOS_GET_MANY = 'CARGOS_GET_MANY';
export const CARGOS_SUMMARY = 'CARGOS_SUMMARY';
export const CARGO_GET_ONE = 'CARGO_GET_ONE';
export const CARGO_ITEMS_MANY = 'CARGO_ITEMS_MANY';
export const CARGOS_ITEMS_MANY = 'CARGOS_ITEMS_MANY';
export const CARGO_ITEM_STATUS_HISTORY = 'CARGO_ITEM_STATUS_HISTORY';
export const CARGOS_SEARCH_HINTS = 'CARGOS_SEARCH_HINTS';

export const TRIPS_GET_MANY = 'TRIPS_GET_MANY';
export const TRIPS_BY_CARGO_ID = 'TRIPS_BY_CARGO_ID';
export const TRIPS_BY_TRUCK_ID = 'TRIPS_BY_TRUCK_ID';
export const TRIP_GET_ONE = 'TRIP_GET_ONE';
export const TRIPS_SEARCH_HINTS = 'TRIPS_SEARCH_HINTS';
export const TRIP_STEPS_MANY = 'TRIP_STEPS_MANY';
export const TRIP_ARRIVAL_INFORMATION = 'TRIP_ARRIVAL_INFORMATION';
export const TRIPS_SUMMARY = 'TRIPS_SUMMARY';
export const CARGO_TRIPS_MANY = 'CARGO_TRIPS_MANY';
export const SELECTED_TOTAL_VALUES = 'SELECTED_TOTAL_VALUES';
export const LAST_TRUCK_TRAILER_PAIRS = 'LAST_TRUCK_TRAILER_PAIRS';

export const TRIP_TASKS_GET_MANY = 'TRIP_TASKS_GET_MANY';

export const INVOICES_GET_MANY = 'INVOICES_GET_MANY';
export const INVOICES_GET_ONE = 'INVOICES_GET_ONE';
export const INVOICES_SEARCH_HINTS = 'INVOICES_SEARCH_HINTS';
export const INVOICES_SUMMARY = 'INVOICES_SUMMARY';

export const EXPENSES_GET_MANY = 'EXPENSES_GET_MANY';
export const EXPENSES_GET_ONE = 'EXPENSES_GET_ONE';
export const EXPENSES_SEARCH_HINTS = 'EXPENSES_SEARCH_HINTS';
export const EXPENSES_TYPES = 'EXPENSES_TYPES';
export const EXPENSES_SUMMARY = 'EXPENSES_SUMMARY';

export const FAVORITES_GET_MANY = 'FAVORITES_GET_MANY';

export const TRANSPORT_MILEAGE_GET = 'TRANSPORT_MILEAGE_GET';
export const STATISTIC_GOALS_GET = 'STATISTIC_GOALS_GET';
export const STATISTIC_GOALS_BY_MANAGER_GET = 'STATISTIC_GOALS_BY_MANAGER_GET';
export const DAILY_LOAD_GOALS_STATISTICS_GET = 'DAILY_LOAD_GOALS_STATISTICS_GET';

export const CLIENT_USERS_GET_MANY = 'CLIENT_USERS_GET_MANY';

export const WAREHOUSE_TASKS_GET_MANY = 'WAREHOUSE_TASKS_GET_MANY';
export const WAREHOUSE_TASK_GET_ONE = 'WAREHOUSE_TASK_GET_ONE';
export const WAREHOUSE_TASKS_SEARCH_HINTS = 'WAREHOUSE_TASKS_SEARCH_HINTS';
export const WAREHOUSE_TASK_ITEMS_GET_MANY = 'WAREHOUSE_TASK_ITEMS_GET_MANY';

export const TRIPS_LOAD_AGGREGATED_STATISTICS_GET = 'TRIPS_LOAD_AGGREGATED_STATISTICS_GET';
export const TRIPS_LOAD_STATISTICS_GET = 'TRIPS_LOAD_STATISTICS_GET';

export const DISTRIBUTION_EFFICIENCY_AGGREGATED_STATISTICS_GET = 'DISTRIBUTION_EFFICIENCY_AGGREGATED_STATISTICS_GET';
export const DISTRIBUTION_EFFICIENCY_STATISTICS_GET = 'DISTRIBUTION_EFFICIENCY_STATISTICS_GET';

export const DISTRIBUTION_AREAS_GET = 'DISTRIBUTION_AREAS_GET';
export const DISTRIBUTION_COST_GET = 'DISTRIBUTION_COST_GET';
export const DISTRIBUTION_COST_BY_MONTHS_GET = 'DISTRIBUTION_COST_BY_MONTHS_GET';

export const OVERDUE_STATISTICS_GET = 'OVERDUE_STATISTICS_GET';
export const OVERDUE_AGGREGATED_STATISTICS_GET = 'OVERDUE_AGGREGATED_STATISTICS_GET';
export const FUTURE_PAYMENTS_STATISTICS_GET = 'FUTURE_PAYMENTS_STATISTICS_GET';
export const FUTURE_EXPENSES_STATISTICS_GET = 'FUTURE_EXPENSES_STATISTICS_GET';
export const TRANSIT_TIME_GET = 'TRANSIT_TIME_GET';
export const TRIPS_LOAD_BY_WAREHOUSES_GET = 'TRIPS_LOAD_BY_WAREHOUSES_GET';

export const STATISTIC_PROFIT_AGGREGATED = 'STATISTIC_PROFIT_AGGREGATED';
export const STATISTIC_PROFIT_BY_DAY = 'STATISTIC_PROFIT_BY_DAY';

export const STATISTIC_PAYMENT_PERIOD = 'STATISTIC_PAYMENT_PERIOD';

export const ADDITIONAL_COSTS_GET_MANY = 'ADDITIONAL_COSTS_GET_MANY';

export const AUDIT_LOGS_GET_MANY = 'AUDIT_LOGS_GET_MANY';

export const WH_PERFORMANCE_STATISTICS_GET = 'WH_PERFORMANCE_STATISTICS_GET';

export const TRANSPORT_LINES_STATISTICS_GET = 'TRANSPORT_LINES_STATISTICS_GET';

export const TRANSPORT_COST_PER_KM_GET = 'TRANSPORT_COST_PER_KM_GET';
